import { getCookie } from '../utils/domUtils';
import { CookiesProviderTypes, AcceptedTrackersType } from './cookies.types';

export const providerKeys: Array<CookiesProviderTypes> = [
  'stats_cookie',
  'onesignal_cookie',
  'facebook_retargeting_cookie',
  'twitter_cookie',
  'ga_cookie',
  'wisepops_cookie',
  'batch_cookie',
];

export const cookiesPolicyName = 'cookies_policy';

export function getCookiesPolicy(): AcceptedTrackersType | null {
  try {
    const cookieString = getCookie(cookiesPolicyName);

    if (cookieString) {
      return JSON.parse(cookieString);
    }
  } catch (error) {
    console.error(error);
    return null;
  }
  return null;
}
